// extracted by mini-css-extract-plugin
export default {"zr-checkbox":"Checkbox_zr-checkbox__kRamK","checkmark":"Checkbox_checkmark__F1osM","zr-checkbox-tree":"Checkbox_zr-checkbox-tree__fCdEs","label-text":"Checkbox_label-text__heCeZ"};